import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=68ac3938&"
import script from "./taskDetail.vue?vue&type=script&lang=tsx&"
export * from "./taskDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports